import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import _cloneDeep from 'lodash/cloneDeep';
import {
  BehaviorSubject,
  Observable,
  Subject,
  filter,
  takeUntil
} from 'rxjs';
import { FormioCustomComponent, FormioLoader } from 'dp-formio';
import { RolesTypeEnum } from '../../../shared/model/roles';
import { IFoData } from './models/formIo-data';
import { visitInfo } from './models/visit';
import { DistributeService } from './services/distribute.service';

type DataType = {
  data: any;
  valid: {
    sessions?: boolean;
    criterions?: boolean;
  };
};
@Component({
  selector: 'app-distribute-team-members',
  templateUrl: './distribute-team-members.component.html',
  styleUrls: ['./distribute-team-members.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FormioLoader],
})
export class DistributeTeamMembersComponent
  implements FormioCustomComponent<any>, OnInit, OnChanges, OnDestroy
{
  destroy$ = new Subject<void>();

  dir: 'rtl' | 'ltr';

  private _defaultValue = {
    data: null,
    valid: {
      sessions: false,
      criterions: false,
    },
  };
  private _value: DataType = null;
  @Input()
  public set value(v) {
    this._value = v;
  }
  public get value() {
    return this._value;
  }
  @Output() valueChange = new EventEmitter();

  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() viewOnly: boolean;

  @Input() customOptions: any;
  @Input() formioComponent: any;

  @Input() data: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.data || changes?.value) {
      this._getVisitInfo(this.data);
    }
  }

  @Input() selectedIndex: 0;

  visitInfoSub = new BehaviorSubject<visitInfo>(null);
  visitInfo$ = this.visitInfoSub.asObservable().pipe(filter(Boolean));
  userRole$: Observable<RolesTypeEnum>;
  constructor(
    private formioLoader: FormioLoader,
    private translateService: TranslateService,
    public router: Router,
    public route: ActivatedRoute,
    public distributeService: DistributeService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private _getVisitInfo(value: IFoData) {
    const data = this.data?.requestDetails?.data;
    const key = data?.projectKey || value?.projectKey;
    if (key) {
      this.distributeService
        .getVisitInfo(key)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.visitInfoSub.next({
            ...this.visitInfoSub.getValue(),
            key: res.visitKey,
            id: res.id,
            requestId: res.requestId,
            number: res.visitNumber,
          });
        });
    }
  }

  ngOnInit(): void {
    this.userRole$ = this.distributeService.getUserType();
  }

  updateValue(payload) {
    this.value = _cloneDeep(payload);
    this.valueChange.emit(payload);
  }

  sessionChanged(isValid: boolean) {
    const data = {
      data: this.value?.data,
      valid: {
        ...this.value?.valid,
        sessions: isValid,
      },
    };
    this.updateValue(data);
  }

  criterionsChanged(isValid: boolean) {
    const data = {
      data: this.value?.data,
      valid: {
        ...this.value?.valid,
        criterions: isValid,
      },
    };
    this.updateValue(data);
  }
}
